import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-logo-page-ui',
    templateUrl: './bb-logo-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LogoPageComponent {}
